import BaseModel from "./BaseModel";

class OrganizationModel extends BaseModel {
  id = "";
  name = "";
  hasList = true;
  hasOrganizationReportUrl = "";
  hasReportUrl = "";

  constructor(options?: any) {
    super(options);
    this.setData(options);
  }
}

export default OrganizationModel;
